import { Button, Divider, Radio, notification } from 'antd';
import { useContext, useState } from 'react';

import { HotelContext } from 'app/context/HotelContext/HotelContext';
import { useConnectChannelManager } from 'app/hooks/data/core/extranet/inventory/rooms/useConnectChannelManager';
import { ChannelManager } from 'app/typings/channelManagers';
import type { ChannelManagerValue } from 'app/typings/channelManagers';
import { getSortedChannelManagersByImportance } from 'app/utils/channelManagerSort';
import { getDerbysoftSuppliersDataSource } from 'app/utils/channelManagers/derbysoft';

import { ChannelManagerTag } from '../../../../_components/ChannelManagerTag/ChannelManagerTag';

import styles from './StepChannelManager.module.scss';
import { StepChannelManagerHeader } from './_components/StepChannelManagerHeader';

export const StepChannelManager = ({ onClose }: { onClose: () => void }) => {
  const [selected, setSelected] = useState<ChannelManagerValue | null>(null);
  const [selectedSupplierId, setSelectedSupplierId] = useState<string | null>(
    null
  );
  const { hotelId } = useContext(HotelContext);

  const { mutateAsync: notifyChannelManagerConnection } =
    useConnectChannelManager(hotelId);

  const channelManagers = getSortedChannelManagersByImportance(
    Object.values(ChannelManager).filter(
      (cm) => cm !== ChannelManager.NONE && cm !== ChannelManager.DERBYSOFT
    )
  );

  const handleConfirm = async (channelManager: ChannelManagerValue) => {
    await notifyChannelManagerConnection({
      channelManager: channelManager,
      ...(selectedSupplierId ? { supplierId: selectedSupplierId } : {}),
    });

    onClose();

    notification.success({
      message: 'Request sent to your Account Manager',
      description: 'They’ll get back to you shortly.',
      duration: 30,
      placement: 'top',
      className: styles.notificationMessage,
    });
  };

  return (
    <div className={styles.stepChannelManager}>
      <StepChannelManagerHeader />

      <Divider className={styles.divider} />

      <div className={styles.managerGrid}>
        {channelManagers.map((channelManager) => (
          <label key={channelManager} className={styles.managerItem}>
            <Radio
              value={channelManager}
              checked={selected === channelManager && !selectedSupplierId}
              onChange={() => {
                setSelected(channelManager);
                setSelectedSupplierId(null);
              }}
            />
            <ChannelManagerTag variant={channelManager} />
          </label>
        ))}
        {getDerbysoftSuppliersDataSource().map((supplier) => (
          <label key={supplier.id} className={styles.managerItem}>
            <Radio
              value={supplier.id}
              checked={selectedSupplierId === supplier.id}
              onChange={() => {
                setSelected(ChannelManager.DERBYSOFT);
                setSelectedSupplierId(supplier.id);
              }}
            />
            <ChannelManagerTag
              variant={ChannelManager.DERBYSOFT}
              supplierId={supplier.id}
            />
          </label>
        ))}
      </div>

      <Divider className={styles.divider} />

      <div className={styles.footer}>
        <Button
          type="primary"
          disabled={!selected}
          onClick={() => selected && handleConfirm(selected)}
        >
          Send request
        </Button>
      </div>
    </div>
  );
};
